export const VERIFIED_METHOD_STATUSES = ['passed', 'valid'] as const

type VerificationStatus = (typeof VERIFIED_METHOD_STATUSES)[number]

const VERIFIED_STATUS_SET = new Set<VerificationStatus>(
    VERIFIED_METHOD_STATUSES.map(status => status.toLowerCase() as VerificationStatus)
)

export const isVerificationMethodStatusSuccessful = (status?: string | null) => {
    if (status) {
        return VERIFIED_STATUS_SET.has(status.toLowerCase() as VerificationStatus)
    } else {
        return false
    }
}
